import Head from 'next/head'
import Image from "next/legacy/image";
import styles from "../styles/pages/Restaurant.module.scss"
import Link from 'next/link'
import Slider from "react-slick";
import Restaurantgallery from '../components/Restaurantgallery/Restaurantgallery'
import DiningPageForm from '../components/Contactusform/DiningPageForm';
import Accordion from '../components/Accordion/Accordion';
import { useState } from 'react';
import RestaurantSchema from '../components/Schema/HotelSchema/restaurant-schema';
import BreadCrumbSchema from '../components/Schema/HotelSchema/breadcrumb';

export default function RestaurantBar() {
    const bannerImages = [
        {
            title: "A wonderful and smooth dining ",
            subheading: "experience awaits you",
            bannerImage: "/images/Gallery/restaurant-banner.jpg"
        },
        {
            title: "Relish delicious food and have a ",
            subheading: "fulfilling experience.",
            bannerImage: "/images/Gallery/res-banner2.jpg"
        },
        {
            title: "Enjoy hearty meal in a calm and ",
            subheading: "relaxing atmosphere.",
            bannerImage: "/images/Gallery/res-banner3.jpg"
        },
    ]

    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false
    };

    // const accordionData = [
    //     {
    //         title: 'Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis?',
    //         content: `Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis. Sed neque lacus nulla dignissim adipiscing. Urna integer morbi ultrices imperdiet morbi mattis Sed neque lacus.`
    //     },
    //     {
    //         title: 'Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis?',
    //         content: `Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis. Sed neque lacus nulla dignissim adipiscing. Urna integer morbi ultrices imperdiet morbi mattis Sed neque lacus.`
    //     },
    //     {
    //         title: 'Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis?',
    //         content: `Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis. Sed neque lacus nulla dignissim adipiscing. Urna integer morbi ultrices imperdiet morbi mattis Sed neque lacus.`
    //     },
    //     {
    //         title: 'Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis?',
    //         content: `Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis. Sed neque lacus nulla dignissim adipiscing. Urna integer morbi ultrices imperdiet morbi mattis Sed neque lacus.`
    //     },
    //     {
    //         title: 'Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis?',
    //         content: `Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis. Sed neque lacus nulla dignissim adipiscing. Urna integer morbi ultrices imperdiet morbi mattis Sed neque lacus.`
    //     },
    //     {
    //         title: 'Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis?',
    //         content: `Lorem ipsum dolor sit amet consectetur. Urna integer morbi ultrices imperdiet morbi mattis. Sed neque lacus nulla dignissim adipiscing. Urna integer morbi ultrices imperdiet morbi mattis Sed neque lacus.`
    //     },

    // ];
    // const [activeIndex, setActiveIndex] = useState(null);

    return (
        <>
            <Head>
                <title>Best Bar and Restaurants | The Twin Towers Hotel in Shimla</title>
                <meta name="description" content="Experience the unforgettable moments of Bar Club and Top Restaurant Shimla at The Twin Towers Hotel in Shimla with stunning views." />
                <link rel="icon" href="/favicon.svg" />
                <link rel="canonical" href="https://www.hoteltwintowers.com/bar-and-restaurant" />
                <meta name="keywords" content="Best Hotels In Kufri best restaurants in Shimla Top Restaurants Shimla bar club best places to eat in Shimla best bars in Shimla best Indian restaurants in Shimla"></meta>
            </Head>
            
            <h1 className='d-none'>A Wonderful Bar Club and Restaurants Shimla</h1>

            <Slider {...settings} className="banner_slider">
                {bannerImages.map((item, index) => (
                    <section key={index}>
                        <div
                            className={styles.restaurant_banner}
                            style={{
                                backgroundImage: `url(${item.bannerImage})`,
                            }}
                            key={index}
                        >
                            <div className={styles.banner_text}>
                                <div className="container">
                                    <div className={`${styles.banner_text_con} common_title`}>
                                        <h2>{item.title}</h2>
                                        <h4>{item.subheading}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                ))}
            </Slider>



            {/* <section
                className={styles.restaurant_banner}
                style={{
                    backgroundImage: 'url("/images/Gallery/restaurant-banner.jpg")',
                }}
            >
                <div className={styles.banner_text}>
                    <div className="container">
                        <div className={`${styles.banner_text_con} common_title`}>
                            <h1>A wonderful and smooth dining experience awaits you</h1>
                            <div className='text-center'>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            <section className={`${styles.restaurant} common_padding`}>
                <div className='container'>
                    <div className={`${styles.restaurant_top} row`}>
                        <div className={`${styles.res_top_left} col-md-6 col-sm-12 common_title`}>
                            <div className={`${styles.center_div} col-md-8`}>
                                <h2>Restaurant</h2>
                                <p>One of the best restaurant in Kufri, where there is something delicious for everyone at our restaurant. Guests may choose from a wide variety of options offering anything from traditional Indian cuisine to international. The home-style meal, which is always made with a local flair, will help you stay healthy throughout your whole trip. Moreover, it allows you to sample some of the regional specialties.</p>
                                <Link href="/contact-us" className="secound_common_btn">Make Reservation</Link>
                            </div>

                        </div>
                        <div className={`${styles.res_top_right} col-md-6 col-sm-12`}>
                            <img src="/images/restaurant.jpg" alt='Restaurant Image' />
                        </div>
                    </div>
                    <div className={`${styles.restaurant_top_two} row`}>
                        <div className={`${styles.res_top_left_two} col-md-6 col-sm-12`}>
                            <img src="/images/bar.jpg" alt='Restaurant Image' />
                        </div>
                        <div className={`${styles.res_top_right_two} col-md-6 col-sm-12 common_title`}>
                            <div className={`${styles.center_div} col-md-8`}>
                                <h2>Bar</h2>
                                <p>Relax and replenish with drinks from the Bar, which has a wide range of mocktails and cocktails made with premium ingredients which makes it the best bar in Kufri. Drink one of our cold beverages, which include fresh juices and other options, to satisfy your thirst. Indulge in some quality time with your loved ones here.</p>
                                <Link href="/contact-us" className="secound_common_btn">Make Reservation</Link>
                            </div>
                        </div>
                    </div>



                    {/* <div className={`${styles.restaurant_top} row align-items-center `}>
                        <div className={`${styles.res_top_right} col-md-6`}>
                            <img src="/images/bar.jpg" alt='Restaurant Image' />
                        </div>
                        <div className='col-md-6 common_title first-order-mobile'>
                            <h2>Bar</h2>
                            <p>Relax and replenish with drinks from the Bar, which has a wide range of mocktails and cocktails made with premium ingredients which makes it the best bar in Kufri. Drink one of our cold beverages, which include fresh juices and other options, to satisfy your thirst. Indulge in some quality time with your loved ones here.</p>
                        </div>
                    </div> */}
                    {/* <div className={styles.restaurant_gal} id="popular_dishes">
                        <div className='common_title'>
                            <h2 className='text-center'>Our Popular Dishes</h2>
                        </div>
                        <div className={styles.gallery_main}>
                            <div className="d-flex justify-content-center py-3">
                                {menuItems.map((Val, id) => {
                                    return (
                                        <button
                                            className={isActive === Val ? 'filtered_btn secound_common_btn mx-2' : 'secound_common_btn mx-2 '}
                                            key={id}
                                            onClick={() => filterItem(Val)}
                                        >
                                            {Val}
                                        </button>
                                    );
                                })}
                            </div>
                            <Slider {...gallery_slider} className="gallery_slider">
                                {item.map((Val, index) => (
                                    <div className={styles.gallery_child} key={Val.id}>
                                        <img src={Val.bgImage} alt={Val.title} />
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div> */}
                    {/* <div className={styles.image_sec}>
                        <div className='common_title text-center'>
                            <h2>We does Fulfill your all needs</h2>
                        </div>
                        <div className={`${styles.bar_image} col-md-12`}>
                            <Image src="/images/hall-image.jpg" layout='fill' objectFit='cover' alt="Bar Image"></Image>
                        </div>
                    </div> */}

                </div>


            </section>
            <Restaurantgallery />
            {/* <section style={{backgroundColor: '#F5F5F5', paddingBottom: '0'}} id='book-a-table'>
                <div className='container'>
                    <DiningPageForm />
                </div>
            </section> */}

            {/* <section className='common_padding' id='firstsec'>
                <div className='container'>
                    <div className='common_title text-center'>
                        <h2>FAQs</h2>
                    </div>
                    <div className='row justify-content-center'>
                        <div className="accordion col-md-9">
                            {accordionData.map(({ title, content }, index) => (
                                <Accordion
                                    title={title}
                                    content={content}
                                    index={index}
                                    activeIndex={activeIndex}
                                    setActiveIndex={setActiveIndex}
                                    key={index}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </section> */}


            {/* <section className={`${styles.restaurant_gal} common_padding`} id="popular_dishes">
                <Slider {...gallery_slider} className="gallery_slider">
                    {gallery.map((item, index) => (
                        <div className={styles.gallery_child} key={index}>
                            <img src={item.image} alt="Food Image" />
                        </div>
                    ))}
                </Slider>
            </section> */}
          <RestaurantSchema />
          <BreadCrumbSchema />
        </>
    )
}
